module.exports = __webpack_public_path__ + "static/img/ISM.bef46a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/expert/ISM.png
// module id = MnSs
// module chunks = 0